import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  const index = state.versetzungsplaene.findIndex(v => v.userId === result.userId)
  if (index >= 0) {
    state.versetzungsplaene[index] = result
  }
  return {
    ...state,
    isLoading: false,
  }
}
fulfilled.chain = (state, payload, result) => actions.versetzungsplan.readVersetzungsplan()

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action(payload) {
  try {
    return await Api.createAbteilung(payload)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
